<template>
    <div class="kiosk-status-panel">
        <p class="kiosk-status-title">{{ title }}</p>
        <p class="kiosk-status-subtitle">{{ subtitle }}</p>

        <kiosk-spinner v-if="status !== 'no_operation'" class="kiosk-status-spinner" />
    </div>
</template>

<script>
import KioskSpinner from './KioskSpinner.vue';

// The kiosk's status screen: "Now Starting", "Now Closing", "No Operation".
// It belongs to kiosk_home.vue alone — the start screen is the only one that
// ever has news about the tablet itself, and each of these names something it
// is actually doing. Nothing inside a session raises it: over a guest who
// tapped a button or pressed Back, the only honest thing it could say is
// nothing, and a screen with nothing to say does not belong on top of theirs.
const STATUS_KEYS = {
    starting: 'virtual_kiosk.now_starting',
    closing: 'virtual_kiosk.now_closing',
    no_operation: 'virtual_kiosk.no_operation',
};

export default {
    name: 'KioskStatusPanel',
    components: { KioskSpinner },
    props: {
        status: {
            type: String,
            default: 'starting',
            validator: (value) => Object.keys(STATUS_KEYS).includes(value),
        },
    },
    computed: {
        // Deliberately not the guest's language. These screens stand between
        // flows — the boot happens before anyone has picked a language, and the
        // closing one runs after the pick is thrown away — so the mockups fix
        // them bilingually: Japanese for the property, English underneath.
        title() {
            return this.$i18n.t(STATUS_KEYS[this.status], 'ja');
        },
        subtitle() {
            return this.$i18n.t(STATUS_KEYS[this.status], 'en');
        },
    },
};
</script>

<style lang="scss" scoped>
.kiosk-status-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
}

.kiosk-status-title {
    font-weight: 500;
    font-size: clamp(22px, 4vw, 32px);
    color: #000;
    margin: 0;
}

.kiosk-status-subtitle {
    font-weight: 700;
    font-size: clamp(22px, 4vw, 32px);
    color: #000;
    margin: 0;
}

/* The spinner itself lives in KioskSpinner.vue. */
.kiosk-status-spinner {
    margin-top: 40px;
}
</style>
